import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=090600cb&scoped=true&"
import script from "./regions.vue?vue&type=script&lang=js&"
export * from "./regions.vue?vue&type=script&lang=js&"
import style0 from "./regions.vue?vue&type=style&index=0&id=090600cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090600cb",
  null
  
)

export default component.exports